export enum LoggerStyle {
  ERROR = 'color: #f27930',
  VALUE = 'color: #2c8ae8',
  SUCCESS = 'color: #8ccc4d',
  DEFAULT = '',
}

export class Logger {
  constructor(private debug: boolean = false) {}
  group(groupName: string, collapsed: boolean = true, style: LoggerStyle = LoggerStyle.DEFAULT): void {
    if (!this.debug) {
      return
    }
    if (collapsed) {
      // eslint-disable-next-line no-console
      console.groupCollapsed(`%c ${groupName}`, style)
    } else {
      // eslint-disable-next-line no-console
      console.group(`%c ${groupName}`, style)
    }
  }

  end(): void {
    if (!this.debug) {
      return
    }
    // eslint-disable-next-line no-console
    console.groupEnd()
  }

  error(...args: unknown[]): void {
    if (!this.debug) {
      return
    }
    // eslint-disable-next-line no-console
    console.log(`%c ${args.join('')}`, LoggerStyle.ERROR)
  }

  success(...args: unknown[]): void {
    if (!this.debug) {
      return
    }
    // eslint-disable-next-line no-console
    console.log(`%c ${args.join('')}`, LoggerStyle.SUCCESS)
  }

  value(arg: unknown): void {
    if (!this.debug) {
      return
    }
    // eslint-disable-next-line no-console
    console.log(`%c ${JSON.stringify(arg, null, 2)}`, LoggerStyle.VALUE)
  }

  log(...args: unknown[]): void {
    if (!this.debug) {
      return
    }
    // eslint-disable-next-line no-console
    console.log(`%c ${args.join('')}`, LoggerStyle.DEFAULT)
  }
}
